import * as React from 'react';
import { useContext } from 'react';
import { MapContext } from './UnitMapTypes';
import '../../../styles/UnitMap.css';
import FormSelect from '../form/FormSelect';

const FloorDropDown = () => {
    const context = useContext(MapContext);
    return context.allFloors ? (
        <FormSelect
            className="floor-dropdown font-weight-bold"
            selectProps={{
                id: 'floor',
                name: 'floor',
                required: true,
                value: context.selectedFloor,
                disabled: false,
                clearable: false,
                searchable: false
            }}
            selectOptions={context.allFloors.map(f => {
                return {
                    value: f.value,
                    label: `Floor: ${f.name}`
                };
            })}
            onChange={(_name, value) => {
                return value && context.selectFloor(value.toString());
            }}
        />
    ) : null;
};

export default FloorDropDown;



// WEBPACK FOOTER //
// ./src/components/common/UnitMap/FloorDropDown.tsx